<template>
    <input
        ref="datePicker"
        :disabled="disabled"
        class="form-input form-datepicker form-control form-input-bordered"
        :class="{ 'cursor-not-allowed': disabled }"
        type="text"
        :placeholder="placeholder"
    />
</template>

<script>
    import flatpickr from 'flatpickr';
    import { German } from 'flatpickr/dist/l10n/de';
    import { Dutch } from 'flatpickr/dist/l10n/nl';
    import 'flatpickr/dist/themes/airbnb.css';
    import { fromUnixTimestamp, toUnixTimestamp } from '@/util/UnixTimestamps';

    export default {
        props: {
            timestamp: {
                type: Number,
                default: null,
            },
            placeholder: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            enableTime: {
                type: Boolean,
                default: true,
            },
            enableDate: {
                type: Boolean,
                default: true,
            },
        },

        data: () => ({ flatpickr: null, shouldOpenOnStart: false }),

        mounted() {
            let locale;

            switch (this.$i18n.locale) {
                case 'de':
                    locale = German;
                    break;

                case 'nl':
                    locale = Dutch;
                    break;

                default:
                    locale = null;
                    break;
            }

            this.$nextTick(() => {
                this.flatpickr = flatpickr(this.$refs.datePicker, {
                    enableTime: this.enableTime,
                    noCalendar: !this.enableDate,
                    enableSeconds: this.enableSeconds,
                    onClose: this.onChange,
                    onChange: this.onChange,
                    defaultDate: this.timestamp ? new Date(fromUnixTimestamp(this.timestamp)) : null,
                    time_24hr: !this.twelveHourTime,
                    locale,
                });

                if (!this.flatpickr.isMobile) {
                    this.flatpickr.set('formatDate', (dateTime) => this.$du(dateTime, this.enableTime ? 'shortDateTime' : 'shortDate'));
                }

                if (this.shouldOpenOnStart) {
                    this.flatpickr.open();
                }
            });

            this.$watch(
                () => (this.timestamp),
                () => { this.redrawFromTimestamp(); },
            );
        },

        destroyed() {
            if (this.flatpickr) this.flatpickr.destroy();
        },

        methods: {
            onChange(selectedDates) {
                if (selectedDates.length === 1) {
                    this.$emit('change', toUnixTimestamp(selectedDates[0].getTime()));
                } else {
                    this.$emit('change', null);
                }
            },
            redrawFromTimestamp() {
                if (!this.timestamp) {
                    this.flatpickr.clear();
                } else {
                    this.flatpickr.setDate(new Date(fromUnixTimestamp(this.timestamp)), false);
                }
            },
        },
    };
</script>
